import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import styled from '@emotion/styled';
import { Grid, Box } from '@mui/material';
import { theme } from '../../themes/default-theme';
import Text from '../../components/typography';
import { useMediaQuery } from '@mui/material';
import ModelSeriesCard from '../../components/content/ModelSeriesCard';
import { setSavedData, getSavedData } from '../../components/methods/setLocalStorage';
import Equalizer from 'react-equalizer';
import { buildPriceData } from '../../components/methods/buildPriceDataName';
import ReactHtmlParser from 'react-html-parser';
import { useRouter } from 'next/router';

const WrapperTop = styled.div`
    ${theme.breakpoints.up('md')} { 
       margin-top: 65px;
    }
    ${theme.breakpoints.down('sm')} { 
        margin-top: 45px;
    }
`

const TopContent = styled.div`
    ${theme.breakpoints.up('md')} { 
        > div {
            padding-bottom: 70px;
            margin-bottom: 38px!important;
            border-bottom: 1px solid ${theme.palette.middleGrey};
        }
        h1 {
            font-size: 60px;
            letter-spacing: 2px;
            margin-bottom: 22px;
        }
    }
    ${theme.breakpoints.down('sm')} { 
      > div {
          margin-top: 30px;
          padding-bottom: 35px;
          margin-bottom: 35px!important;
          border-bottom: 1px solid ${theme.palette.middleGrey};
      }
    }
`
const TopContentInner = styled.div`
    max-width: 984px;
    margin-left: auto;
    margin-right: auto;
    ${theme.breakpoints.up('md')} { 

    }
    ${theme.breakpoints.up('sm')} { 

    }
`

const Wrapper = styled.div`
  width:100%;
  ${theme.breakpoints.up('lg')} { 
    &:not(:last-child) {
        > div {
            padding-bottom:60px;
            margin-bottom: 38px;
            border-bottom: 1px solid ${theme.palette.middleGrey};
        }
    }
  }
  .grid-item {
    ${theme.breakpoints.up('lg')} { 
      padding-top:0;
      padding-bottom:0;
      &:first-child {
        padding-left:0;
      }
      &:last-child {
        padding-right:0;
      }
    }
    ${theme.breakpoints.down('md')} { 
      padding-left:0;
      padding-right:0;
      &:first-child {
        padding-top:0;
      }
      &:last-child {
        padding-bottom:0;
      }
    }
  }
`

const Intro = styled.div`
  text-align: left;

  h3 {
    font-weight:800;
    margin-bottom:12px;
    ${theme.breakpoints.up('md')} { 
        font-size: 27px;
        line-height: 26px;
    }
  }
  p {
    &:last-child {
      margin-bottom:0;
      padding-bottom:0;
    }
  }
  ${theme.breakpoints.down('sm')} { 
    text-align:center;
    max-width:100%;
    p, div {
      text-align:center;
    }
    h3 {
      text-align:center;
      padding:8px;
      width:100%;
    }
  }
  a {
    font-size:13px;
    color:${theme.palette.gunmentalGrey};
    text-decoration:none;
    font-weight:700;
    margin-top:8px;
    display:inline-block;
    ${theme.breakpoints.up('md')} { 
      font-size:16px;
    }
    &:hover {
      color:${theme.palette.vividBlue};
    }
  }
`
const SeriesCardContainer = styled(Equalizer)`  
  width:100%;
  text-align:center;
  display:flex;
  align-items:flex-start;
  justify-content:flex-start;
  flex-direction:row;
  flex-wrap:wrap;
  gap:10px;
  margin-bottom: 18px;
  ${theme.breakpoints.down('sm')} {
    gap:20px;
  }
`

const SeriesCardItem = styled.div`
  width:49%;
  display: flex;
  font-size: 12px;
  
  ${theme.breakpoints.up('lg')} { 
    width:32%;
  }
  ${theme.breakpoints.down('md')} {
    justify-content: center;
  }
  ${theme.breakpoints.down('sm')} {
    h4 {
      text-align: center;
    }
     width: calc(47% - 10px);
    a {
      display:inline-block;
      width:auto;
    }
  }
  div {
    padding:0;
    justify-content:center;
  }
  h3 {
    text-align:center;
  }
  picture, img {
    width: 275px;
    ${theme.breakpoints.down('sm')} {
      width:100%;
      max-width:275px;
    }
  }
`


const modelSelectPageDataDefaultPropSeries = [];


const ModelSelectPageData = (props) => {
    props = {
        ...props,
        title: typeof props.title === "undefined" ? null : props.title,
        text: typeof props.text === "undefined" ? null : props.text,
        series: typeof props.series === "undefined" ? modelSelectPageDataDefaultPropSeries : props.series
    };

    const {
        title,
        text,
        series
    } = props

    const [showBuildAndPrice, setShowBuildAndPrice] = useState(true);
    const router = useRouter();
    let res = JSON.parse(getSavedData(buildPriceData)) || {};
    const desktopView = useMediaQuery(theme.breakpoints.up('md'));
    const mobileView = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        // if((document.location.hostname == 'www.jaycoadelaide.com.au') || (document.location.hostname == 'www.jaycoalbertpark.com.au') || (document.location.hostname.indexOf('jayco-com-au.au1.staticlyproject.com') > -1) || (document.location.hostname.indexOf('localhost') > -1)) {
        //   setShowBuildAndPrice(true)
        // } else {
        //   setShowBuildAndPrice(false)
        //   router.push('/404')
        // }
    }, [])

    const handleSaveData = (seriesName) => {
        
        if (res && res.seriesName && seriesName && res.seriesName == seriesName) {
            res.seriesName = seriesName
            setSavedData(
                buildPriceData,
                JSON.stringify(
                    res
                ),
                86400 // 1 day
            );

        } else {
            res = {};
            res.seriesName = seriesName;
            setSavedData(
                buildPriceData,
                JSON.stringify(
                    res
                ),
                86400 // 1 day
            );
        }
    }

    return (showBuildAndPrice && <WrapperTop>
        <Box px={2}>
          {(title || text) &&
            <TopContent>
                <Grid container justify={'center'}>
                    <TopContentInner>
                        {title &&
                            <Text variant="h1" colour="charcoal" weight={800} uppercase="true" align="center">{ReactHtmlParser(title)}</Text>
                        }
                        {text &&
                            <Text variant="body1" align="center">{ReactHtmlParser(text)}</Text>
                        }
                    </TopContentInner>
                </Grid>
            </TopContent>
          }
          {   series && series.length > 0 && series.map((item, index) => {
                  return (
                      <Wrapper key={index}>
                          <Grid container spacing={desktopView ? 5 : 3} direction={desktopView ? 'row' : 'column'} wrap="wrap" justifyContent={'space-between'} align={'flex-start'}>
                              <Grid
                                  className="grid-item"
                                  size={{
                                      xs: 12,
                                      lg: 3
                                  }}>
                                  <Intro>
                                      {item.range && item.range.title &&
                                          <Text variant="h3" colour="vividBlue" uppercase="true" align="left">{item.range.title}</Text>
                                      }
                                      {item.range && item.range.text &&
                                          <Text variant="body1" align="left">{item.range.text}</Text>
                                      }
                                  </Intro>
                              </Grid>
                              <Grid
                                  className="grid-item"
                                  size={{
                                      xs: 12,
                                      lg: 9
                                  }}>
                                  <SeriesCardContainer>
                                      {item.range && item.range.series && item.range.series.length > 0 && item.range.series.map((item, index) => {
                                          return (
                                              <SeriesCardItem key={item.title}>
                                                  <ModelSeriesCard
                                                      href={item.href}
                                                      title={item.title}
                                                      subTitle={item.subTitle}
                                                      sleeps={item.sleeps}
                                                      image={item.image}
                                                      hasborder='false'
                                                      handleSaveData={handleSaveData}
                                                  />
                                              </SeriesCardItem>
                                          )
                                      })}
                                  </SeriesCardContainer>
                              </Grid>
                          </Grid>
                      </Wrapper>
                  );
              })
          }
        </Box>
    </WrapperTop>);
}

ModelSelectPageData.propTypes = {
    title: propTypes.string,
    text: propTypes.string,
    series: propTypes.array
}

export default ModelSelectPageData